"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Radio = require("@mui/material/Radio");

var _Radio2 = _interopRequireDefault(_Radio);

var _QuestionContainer = require("../QuestionContainer");

var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _QuestionText = require("../QuestionText");

var _QuestionText2 = _interopRequireDefault(_QuestionText);

var _AsyncDropdown = require("../AsyncDropdown");

var _AsyncDropdown2 = _interopRequireDefault(_AsyncDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Row = _styledComponents2.default.div`
  display: flex;
  align-items: center;
`;
const AnswerContainer = _styledComponents2.default.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const APIAutocompleteQuestion = ({
  question,
  onChangeAnswer,
  autocompleteRequest
}) => {
  const [answer, changeAnswer] = (0, _react.useState)(question.defaultAnswer || undefined);
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined
  }, _react2.default.createElement(_AsyncDropdown2.default, {
    id: question.id ? question.id : "",
    answer: answer,
    placeholder: question.placeholder,
    requestUrl: question.requestUrl,
    autocompleteRequest: autocompleteRequest,
    onChange: onChangeAnswer
  }));
};

exports.default = APIAutocompleteQuestion;